// extracted by mini-css-extract-plugin
export default {"controlButton":"pQfNDU","hidden":"m0olOu","loader":"unS3vX","rotate":"ceIfOi","active":"lz7Xp1","clip":"bOIQdx","clip-reverse":"vVZFOq","clipReverse":"vVZFOq"};